import React, { useEffect, useState } from 'react'
import { Spinner } from '@welbe/web-design-system'
import PaypalCheckout from './components/PaypalCheckout'
import { sendMessage } from 'services/messenger'
import { decodeUrl } from 'utils/decode'
import { transformOrder } from 'utils/helpers'
import { LoadingWrapper, CheckoutWrapper } from './PaymentCheckout.styles'

const loadFraudnet = () => {
	const script = document.createElement('script')
	script.src = 'https://c.paypal.com/da/r/fb.js'
	document.body.appendChild(script)
	console.warn('Loaded fraudnet')
}

export function PaymentCheckout() {
	const [isLoading, setLoading] = useState<boolean>(true)
	const [order, setOrder]: any = useState(undefined)
	const [credentials, setCredentials]: any = useState(undefined)

	const handlePayload = (payload: any) => {
		if (!payload || !payload.order) {
			return sendMessage({
				status: 'error',
				data: { message: 'invalid-order', order: payload.order },
			})
		}
		if (!payload.credentials) {
			return sendMessage({
				status: 'error',
				data: { message: 'invalid-credentials' },
			})
		}
		setOrder(payload.order)
		setCredentials(payload.credentials)
	}

	const getPayload = async () => {
		setLoading(true)
		let payload: any = false
		try {
			const orderDecoded = decodeUrl(window.location.search)
			payload =
				orderDecoded?.order?.type === 'PAYMENT'
					? await transformOrder(orderDecoded)
					: orderDecoded
		} catch (e: any) {
			sendMessage({
				status: 'error',
				data: { message: 'invalid-token' },
			})
			payload = false
		} finally {
			handlePayload(payload)
			setLoading(false)
		}
	}

	useEffect(() => {
		document.title = 'Payment checkout'
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		document.body.style = 'background: white;'
		loadFraudnet()
	}, [])

	useEffect(() => {
		getPayload()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (!order || isLoading)
		return (
			<LoadingWrapper>
				<Spinner size="24px" />
			</LoadingWrapper>
		)

	return (
		<CheckoutWrapper>
			<PaypalCheckout order={order} credentials={credentials} />
		</CheckoutWrapper>
	)
}
